import { useRef } from 'react'
import NumberFormat from 'react-number-format'
import { focus } from 'src/utils'
import styled from 'styled-components'
import uniqid from 'uniqid'
import SearchIcon from '../../../static/icons/search-icon.svg'
import { Button } from './input'

const Container = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  margin: ${props => props.margin ? props.margin : '2rem auto'};
  scroll-margin-top: 134px;

  input[type="text"]::placeholder {
    font-family: var(--primary-font) !important;
    color: var(--gray-7);
    font-size: 14px;
    font-weight: 400;
    line-height: 19.07px;
  }
`

export const Label = styled.label`
  position: absolute;
  top: -18px;
  left: 14px;
  background-color: var(--the-white);
  color: var(--gray-5);
  font-size: 14px;
  font-family: var(--primary-font);
  font-weight: 400;
  padding: 4px;
  z-index: 1;

  ${props => props.hasError && 'color: red;'}
`

export const InputStyled = styled(NumberFormat)`
  background-color:  var(--the-white);
  border: 1px solid var(--gray-7);
  border-radius: 16px;
  width: inherit;
  height: 45px;
  padding: 1rem;
  outline: none;
  color: ${props => props.readOnly ? 'var(--rain-cloud)' : 'var(--gray-5)'};
  ${props => props.hasError && `
    color: red;
    border: 1px solid red;
  `}
  ${props => props.hasIcon && 'padding-left: 38px;'}
  font-size: 16px;
  font-family: var(--primary-font);
  font-weight: 400;

  &::placeholder {
    font-family: var(--primary-font) !important;
    font-size: 16px;
    font-weight: 400;
  }
`

const formatCallBack = (name, event) => {
  const { value } = event
  return { target: { name, value } }
}

const InputMask = ({ dataTest, margin, name, label, onChange, value, mask, placeholder, width, icon, onSearchButtonClick = false, disabledButton = false, ...props }) => {
  const id = uniqid()
  const inputRef = useRef(null)
  const handleFocus = (event) => {
    focus(inputRef, 'smooth', true)
    if (props.onFocus) {
      props.onFocus(event)
    }
  }
  return (
    <Container ref={inputRef} margin={margin} data-test={dataTest + '-container'}>
      <Label data-test={dataTest + '-label'} htmlFor={id}>{label}</Label>
      <InputStyled
        id={id}
        name={name}
        onValueChange={(event) => onChange(formatCallBack(name, event))}
        value={value}
        data-test={dataTest}
        format={mask}
        placeholder={placeholder}
        width={width}
        {...props}
        onFocus={(e) => handleFocus(e)}
      />
      {icon === 'search' && <Button onClick={onSearchButtonClick} disabledButton={disabledButton}> <SearchIcon /></Button>}
    </Container>
  )
}

export default InputMask
